import { useState } from 'react';
import { universalSearch } from '../searchService';

/**
 * Custom hook for universal search functionality (addresses, coins, tokens)
 */
export const useUniversalSearch = () => {
  const [searchAddress, setSearchAddress] = useState('');
  const [searchResults, setSearchResults] = useState({ addresses: [], coins: [], totalResults: 0 });
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  const handleSearch = async (searchTerm = null) => {
    // Use provided searchTerm or fall back to state
    const term = searchTerm !== null ? searchTerm : searchAddress;

    // Ensure term is a string (handle cases where event object might be passed)
    const termString = typeof term === 'string' ? term : String(term || '');
    const trimmed = termString.trim();

    if (trimmed.length < 2) {
      setSearchResults({ addresses: [], coins: [], totalResults: 0 });
      setShowSearchResults(false);
      return;
    }

    try {
      setSearchLoading(true);
      const results = await universalSearch(trimmed, 5);
      setSearchResults(results);
      setShowSearchResults(true);
    } catch (error) {
      console.error('Search error:', error);
    } finally {
      setSearchLoading(false);
    }
  };

  return {
    searchAddress,
    setSearchAddress,
    searchResults,
    showSearchResults,
    setShowSearchResults,
    searchLoading,
    handleSearch
  };
};
